<!--
 * @Author: your name
 * @Date: 2019-11-08 16:37:16
 * @LastEditTime : 2020-01-08 16:44:39
 * @LastEditors  : Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \source\src\components\onlineMap\collectFolder\UCCollectFolder.vue
 -->
<!--  -->
<template>
  <div class="div_ucCollectFolder">

    <div class="div_title">收藏夹</div>

    <div
      v-show="curUser"
      style="width:100%;height:80%"
    >

      <div class="collect_header ">

        <div class="collect_header_left">
          <a @click="_headerClickHandler">
            <i
              v-show="componentSetting.i_add_folder_visible"
              class="com-icon "
            ></i>

            {{componentSetting.curHeaderOperDesc}}</a>

        </div>
      </div>

      <div style="width:100%;height:80%; overflow: auto;">
        <UCCollectFolderList
          ref="ucFolder"
          v-show="componentSetting.folderVisible"
        ></UCCollectFolderList>

        <UCCollectItemList
          ref="ucItem"
          v-show="componentSetting.itemVisible"
        ></UCCollectItemList>

      </div>

    </div>

    <div
      v-if="!curUser"
      class="collect_to_login"
    >
      <h3 class="c_login_tip">您尚未登录，请
        <a
          class="c_login_text"
          :href="platformHref.login"
        >登录</a>
        后使用!
      </h3>
      <p>随时随地查看和管理您收藏的地点和标绘的内容！</p>
    </div>

    <UCFormCollectFolder ref="ucFormFolder"></UCFormCollectFolder>

  </div>
</template>

<script>
import UCCollectFolderList from "./UCCollectFolderList.vue";
import UCFormCollectFolder from "./UCFormCollectFolder.vue";
import UCCollectItemList from "./UCCollectItemList.vue";

import { UCCollectFolderConsts } from "./UCCollectFolderJs.js";

import { UCOperationType } from "../UCComponentJs";
import { TdtUser } from "../model/TdtUserJs";
import { ServiceUrlConfig } from "../../../config/ServiceUrlConfigJs";

export default {
  name: "UCCollectFolder",
  data() {
    return {
      componentSetting: {
        //新建收藏夹是否可见
        i_add_folder_visible: true,

        folderVisible: true,
        itemVisible: false,

        //header当前操作类型
        curHeaderOperType:
          UCCollectFolderConsts.headerOperationTypes.folder_add_new,
        //header当前操作描述
        curHeaderOperDesc:
          UCCollectFolderConsts.headerOperationTypes.folder_add_new_desc
      },

      curUser: null,

      platformHref: {
        login: ServiceUrlConfig.platform_tdtsso_fullLogin
      }
    };
  },

  components: { UCCollectFolderList, UCCollectItemList, UCFormCollectFolder },

  computed: {},

  mounted() {},

  methods: {
    init() {
      this.curUser = TdtUser.currentUser;

      this.componentSetting.folderVisible = true;
      this.componentSetting.itemVisible = false;
      this.componentSetting.i_add_folder_visible = true;
      this.componentSetting.curHeaderOperType =
        UCCollectFolderConsts.headerOperationTypes.folder_add_new;
      this.componentSetting.curHeaderOperDesc =
        UCCollectFolderConsts.headerOperationTypes.folder_add_new_desc;

      if (this.$refs.ucFolder) {
        this.$refs.ucFolder.init();
      }

      this._initEvents();
    },

    on_ucCollectItem_nodeCheckedChange(callback) {
      if (callback) {
        if (this.$refs.ucItem) {
          this.$refs.ucItem.on_nodeCheckedChange(callback);
        }
      }
    },

    off_ucCollectItem_nodeCheckedChange(callback) {
      if (callback) {
        if (this.$refs.ucItem) {
          this.$refs.ucItem.off_nodeCheckedChange(callback);
        }
      }
    },

    on_ucCollectItem_deleteNode(callback) {
      if (callback) {
        if (this.$refs.ucItem) {
          this.$refs.ucItem.on_deleteNode(callback);
        }
      }
    },

    off_ucCollectItem_deleteNode(callback) {
      if (callback) {
        if (this.$refs.ucItem) {
          this.$refs.ucItem.off_deleteNode(callback);
        }
      }
    },

    _initEvents() {
      let self = this;
      if (this.$refs.ucFolder) {
        this.$refs.ucFolder.off_folderItemClick(self._ucfolderItemClickHandler);
        this.$refs.ucFolder.on_folderItemClick(self._ucfolderItemClickHandler);
      }

      if (this.$refs.ucFormFolder) {
        this.$refs.ucFormFolder.off_addSucceed(
          self._ucFormFolderAddSucceedHandler
        );
        this.$refs.ucFormFolder.on_addSucceed(
          self._ucFormFolderAddSucceedHandler
        );
      }
    },

    _ucfolderItemClickHandler(folderItem) {
      if (!folderItem) return;

      this.componentSetting.curHeaderOperType =
        UCCollectFolderConsts.headerOperationTypes.back_to_all_folder;
      this.componentSetting.curHeaderOperDesc =
        UCCollectFolderConsts.headerOperationTypes.back_to_all_folder_desc +
        "> " +
        folderItem.name;

      this.componentSetting.i_add_folder_visible = false;
      this.componentSetting.folderVisible = false;
      this.componentSetting.itemVisible = true;

      this.$refs.ucItem.curCollectFolderId = folderItem.id;
      this.$refs.ucItem.init();
    },

    _headerClickHandler() {
      if (
        this.componentSetting.curHeaderOperType ===
        UCCollectFolderConsts.headerOperationTypes.folder_add_new
      ) {
        this.$refs.ucFormFolder.init(UCOperationType.operation_add, null);

        this.$refs.ucFormFolder.showForm();
      } else if (
        this.componentSetting.curHeaderOperType ===
        UCCollectFolderConsts.headerOperationTypes.back_to_all_folder
      ) {
        this.componentSetting.i_add_folder_visible = true;
        this.componentSetting.folderVisible = true;
        this.componentSetting.itemVisible = false;

        this.componentSetting.curHeaderOperType =
          UCCollectFolderConsts.headerOperationTypes.folder_add_new;
        this.componentSetting.curHeaderOperDesc =
          UCCollectFolderConsts.headerOperationTypes.folder_add_new_desc;
      }
    },

    _ucFormFolderAddSucceedHandler(folder) {
      if (!folder) return;

      //追加到文件夹列表上
      this.$refs.ucFolder.addFolder(folder);
    }
  }
};
</script>


<style lang="scss" scoped>
.collect_header {
  width: 100%;
  display: table;
  background: #f2f2f2;
  // font-size: 12px;
  padding: 7px 20px;
  margin-bottom: 5px;
}

.collect_header .collect_header_left {
  float: left;
  font-size: 12px;
  // color: #2f87eb;
  font-weight: 700;

  a {
    color: #2f87eb;
  }

  a:hover {
    cursor: pointer;
  }
}

.collect_panel .collect_header .add_icon {
  display: inline-block;
  margin-right: 5px;
}

.com-icon {
  background: url("../../../assets/onlineMap/icon.png");
  background-position: -200px -185px;
  width: 10px;
  height: 10px;
  display: inline-block;
}

.div_ucCollectFolder {
  height: 100%;
  width: 100%;

  .div_title {
    text-align: center;
    width: 100%;
    height: 50px;
    line-height: 50px;
    font-size: 16px;
    font-weight: 700;
  }
}

.collect_to_login {
  padding: 0 20px;

  p {
    font-size: 12px;
    margin-bottom: 7px;
  }

  .c_login_tip {
    padding: 0;
    margin: 0;
    margin-bottom: 7px;
    font-size: 12px;

    .c_login_text {
      color: #2f87eb;
    }
  }

  h3 {
    display: block;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    font-weight: bold;
  }
}
</style>
